import { memo } from 'react';

// A locale-independent date + 24-hour time picker. `value` is a local
// "YYYY-MM-DDTHH:mm" string (same shape as a <input type="datetime-local">),
// or '' / undefined. It pairs a native date calendar with explicit 24-hour
// hour/minute selects, so the time is NEVER shown as 12h AM/PM regardless of
// the browser locale (Safari ignores the `lang` attribute on datetime-local).
//
// It is memoized so a parent that re-renders on a timer (the auction console
// ticks every 500ms) does not reset the field while the operator is editing;
// pass a stable `onChange` (e.g. a useState setter).

const pad2 = (n) => String(n).padStart(2, '0');
const HOURS = Array.from({ length: 24 }, (_, i) => pad2(i));
const MIN_STEP = ['00', '05', '10', '15', '20', '25', '30', '35', '40', '45', '50', '55'];

const DateTimePicker = memo(function DateTimePicker({ value, onChange, className = '' }) {
    const [datePart = '', timePart = ''] = (value || '').split('T');
    const [hh = '', mm = ''] = timePart.split(':');
    // Keep an unusual stored minute (e.g. 07) selectable.
    const minutes = (!mm || MIN_STEP.includes(mm)) ? MIN_STEP : [...MIN_STEP, mm].sort();

    const emit = (d, h, m) => onChange(d && h !== '' && m !== '' ? `${d}T${h}:${m}` : '');

    return (
        <div className={`dtpicker ${className}`}>
            <input
                type="date"
                className="cx-input dtpicker-date"
                value={datePart}
                onChange={(e) => emit(e.target.value, hh || '00', mm || '00')}
            />
            <div className="dtpicker-time">
                <select className="cx-select dtpicker-sel" value={hh} onChange={(e) => emit(datePart, e.target.value, mm || '00')} aria-label="საათი">
                    <option value="" disabled>სთ</option>
                    {HOURS.map((h) => <option key={h} value={h}>{h}</option>)}
                </select>
                <span className="dtpicker-colon">:</span>
                <select className="cx-select dtpicker-sel" value={mm} onChange={(e) => emit(datePart, hh || '00', e.target.value)} aria-label="წუთი">
                    <option value="" disabled>წთ</option>
                    {minutes.map((m) => <option key={m} value={m}>{m}</option>)}
                </select>
            </div>
        </div>
    );
});

export default DateTimePicker;
